<div
  class="main-layout"
  [style.--open-toasts-count]="openToastsCount()"
  [style.--support-banner-count]="supportMode.isSupport() ? 1 : 0">
  <ui-toast></ui-toast>

  @if (supportMode.isSupport()) {
    <app-support-banner class="main-support-banner" />
  }

  <div class="main">
    <app-menu class="main-menu"></app-menu>

    <div class="main-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>